import Icon from '@ant-design/icons/lib/components/Icon';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { ReactComponent as FaqSvg } from './assets/faq.svg';
import { Button } from 'antd';
import { BaseMsgProps } from 'views/Conversation/Chat/components/MessageType/types';
import FaqModal from 'views/Conversation/Chat/components/FaqModal';
import useModal from 'hooks/useModal';

const Container = styled.div`
  min-width: 300px;
  max-width: 450px;
  background: var(--fett-chat-card-bg);
  color: var(--fett-text-primary);
  border-radius: 4px;
  > div {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: solid 1px var(--fett-border-default);
    > span {
      margin-right: 4px;
      font-size: 18px;
    }
  }
  > section {
    padding: 8px 12px;
    > ul {
      margin: 0;
      padding: 8px 12px;
      list-style: none;
      background: var(--fett-bg-subtle);
      color: var(--fett-text-tertiary);
      > li {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    > button {
      padding-left: 0;
    }
  }
`;

function BundleMessage(props: BaseMsgProps) {
  const { t } = useTranslate();

  const { visible, show, hide, meta } = useModal<BaseMsgProps>();

  const { bundleMessageContent } = props.raw;

  if (!bundleMessageContent) {
    return <></>;
  }

  return (
    <Container>
      <div>
        <Icon component={FaqSvg} />
        {t('messageType.BUNDLE_MESSAGE')}
      </div>
      <section>
        <ul>
          {bundleMessageContent.summaries.map(({ fromUserName, messageType, text }) => {
            return (
              <li>
                {fromUserName}：
                {messageType === 'FAQ_FEEDBACK_PROMPT'
                  ? 'Was this answer helpful？'
                  : messageType === 'FAQ_UNSUPPORTED'
                  ? t('faqUnsupported')
                  : [
                      'TEXT',
                      'IMAGE_WITH_TEXT',
                      'FAQ_CATEGORY_CHOICE',
                      'FAQ_FEEDBACK',
                      'FAQ_LIVEAGENT_PROMPT',
                      'FAQ_QUESTION_LIST',
                      'FAQ_QUESTION',
                      'SHOPEE_RICH_TEXT',
                      'FAQ_BOT_REQUEST_TEXT',
                      'NEW_FAQ',
                    ].includes(messageType)
                  ? text
                  : `[${t(`messageType.${messageType}`)}]`}
              </li>
            );
          })}
        </ul>
        <Button type="link" onClick={() => show(props)}>
          {t('查看全部FAQ')}
        </Button>
      </section>
      {meta && (
        <FaqModal
          conversation={meta.conversation}
          msgId={meta.raw.msgId}
          visible={visible}
          onCancel={() => hide()}
        />
      )}
    </Container>
  );
}

export default BundleMessage;
